const {
  GET_TICKET_DETAIL_LIST,
  GET_CUSTOMER_TICKET_DETAIL_LIST,
  GET_CUSTOMER_TICKET_DETAIL_LIST_API,
  GET_CUSTOMER_VEHICLE_DETAIL,
  GET_CUSTOMER_VEHICLE_LIST,
  GET_OFFLINE_INTIMATION,
  GET_VEHICLE_OWNER_NOTIFICATION,
  MARK_VEHICLE_OWNER_NOTIFICATION_READ,
} = require("src/actions/types");

const initialState = {
  TicketData: [],
  customerTicketData: [],
  customerVehicleDetailsData: [],
  customerTicketDataApi: [],
  customerVehicleListData: [],
  offlineIntimationData: [],
  vehicleOwnerNotificationData: [],
  vehicleOwnerNotificationReadData: [],
};

const ComplaintReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_TICKET_DETAIL_LIST:
      return {
        ...state,
        TicketData: payload,
      };
    default:
      return state;
  }
};
const CustomerTicketListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUSTOMER_TICKET_DETAIL_LIST:
      return {
        ...state,
        customerTicketData: payload,
      };
    default:
      return state;
  }
};
const CustomerTicketListApiReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUSTOMER_TICKET_DETAIL_LIST_API:
      return {
        ...state,
        customerTicketDataApi: payload,
      };
    default:
      return state;
  }
};
const CustomerVehicleDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUSTOMER_VEHICLE_DETAIL:
      return {
        ...state,
        customerVehicleDetailsData: payload,
      };
    default:
      return state;
  }
};
const CustomerVehiclesListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUSTOMER_VEHICLE_LIST:
      return {
        ...state,
        customerVehicleListData: payload,
      };
    default:
      return state;
  }
};
const offlineIntimationReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_OFFLINE_INTIMATION:
      return {
        ...state,
        offlineIntimationData: payload,
      };
    default:
      return state;
  }
};
const vehicleOwnerNotificationReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_VEHICLE_OWNER_NOTIFICATION:
      return {
        ...state,
        vehicleOwnerNotificationData: payload,
      };
    case MARK_VEHICLE_OWNER_NOTIFICATION_READ:
      return {
        ...state,
        vehicleOwnerNotificationReadData: payload,
      };
    default:
      return state;
  }
};

export {
  ComplaintReducer,
  CustomerTicketListReducer,
  CustomerVehicleDetailsReducer,
  CustomerTicketListApiReducer,
  CustomerVehiclesListReducer,
  offlineIntimationReducer,
  vehicleOwnerNotificationReducer,
};
